<!-- Toast Container Component -->
<template>
  <div class="fixed top-0 right-0 p-4 z-50 flex flex-col items-end">
    <Toast 
      v-for="toast in toasts" 
      :key="toast.id" 
      :toast="toast" 
      @close="removeToast(toast.id)"
    />
  </div>
</template>

<script setup lang="ts">
import { useCustomToast } from '~/layers/base/composables/useCustomToast'
import Toast from '~/layers/base/components/ui/toast/Toast.vue'

// Get toasts from provider
const { toasts, removeToast } = useCustomToast()
</script>

<style scoped>
.toast-container {
  pointer-events: none;
}
</style> 